import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApireferenceComponent } from './apireference.component';
import { ApiReferenceNavigationComponent } from './apireference-navigation/apireference-navigation.component';
import { RouterModule } from '@angular/router';
import { APIReferenceRoutingModule } from './apireference-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { MaterialModule } from 'src/app/shared/material-module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    APIReferenceRoutingModule,
    CoreModule,
    MaterialModule
  ],
  declarations: [
  ApireferenceComponent,
  ApiReferenceNavigationComponent,
  ]
})
export class ApireferenceModule { }
